const getApiBase = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Production API Gateway
  return 'https://ivyhwi60lf.execute-api.ap-south-1.amazonaws.com/prod/api';
};

export const API_BASE = getApiBase();